{
    "Accessibility menu": "မည်သူမဆို အသုံးပြုနိုင်သော မီနူး",
    "Close": "ပိတ်ပါ",
    "Content adjustments": "အကြောင်းအရာ ချိန်ညှိမှုများ",
    "Navigation adjustments": "လမ်းညွှန်ချိန်ညှိမှုများ",
    "Text Align": "Text Align",
    "Align Left": "ဘယ်ဘက်သို့ ညှိပါ",
    "Align Center": "Align Center",
    "Align Right": "Align Right",
    "Adjust Font Size": "ဖောင့်အရွယ်အစားကို ချိန်ညှိပါ",
    "Highlight Title": "ခေါင်းစဉ်ကို အထူးပြုပါ",
    "Highlight Links": "လင့်များကို အထူးပြုပါ",
    "Readable Font": "ဖတ်ရန်လွယ်ကူသော ဖောင့်",
    "Colour adjustments": "အရောင် ချိန်ညှိမှုများ",
    "Dark Contrast": "မှောင်မိုက်သော ကွာခြားမှု",
    "Light Contrast": "အလင်းရောင် ကွာခြားမှု",
    "High Contrast": "မြင့်မားသော ကွာခြားမှု",
    "High Saturation": "မြင့်မားသော အရောင်စွဲမှု",
    "Low Saturation": "နိမ့်သော အရောင်စွဲမှု",
    "Monochrome": "တစ်ရောင်တည်း",
    "Tools": "ကိရိယာများ",
    "Reading Guide": "ဖတ်ရှုရန် လမ်းညွှန်",
    "Big Cursor": "ကြီးမားသော ကာဆာ",
    "Increase Font Size": "ဖောင့်အရွယ်အစားကို တိုးချဲ့ပါ",
    "Decrease Font Size": "ဖောင့်အရွယ်အစားကို လျှော့ချပါ",
    "Letter Spacing": "အက္ခရာအကြား အကွာအဝေး",
    "Line Height": "စာကြောင်းအမြင့်",
    "Font Weight": "ဖောင့်အလေးချိန်",
    "Dyslexia Font": "Dyslexia ဖောင့်",
    "Language": "ဘာသာစကား",
    "Accessibility widget": "မည်သူမဆို အသုံးပြုနိုင်သော မီနူးကို ဖွင့်ပါ",
    "Accessibility Profiles": "မည်သူမဆို အသုံးပြုနိုင်သော ပရိုဖိုင်များ",
    "Cognitive Disability": "သိမြင်မှုဆိုင်ရာ မသန်စွမ်းမှု",
    "Seizure Safe": "အတက်ရောဂါအတွက် ဘေးကင်းလုံခြုံသော",
    "Accessibility statement": "မည်သူမဆို အသုံးပြုနိုင်သော ကြေညာချက်",
    "ADHD": "ADHD",
    "Low Vision": "Low Vision",
    "Pause Animations": "အန်နီမေးရှင်းများကို ရပ်ပါ",
    "Reset all settings": "ဆက်တင်များကို ပြန်လည်သတ်မှတ်ပါ",
    "Shortcut:": "Shortcut:",
    "Epilepsy Safe Mode": "Epilepsy Safe Mode",
    "Mute sounds": "Mute sounds",
    "Page read": "Page read",
    "Page read controls": "Page read controls",
    "Pause": "Pause",
    "Resume": "Resume",
    "Stop": "Stop",
    "Settings": "Settings",
    "Speed": "Speed",
    "Voice": "Voice"
}
